import { IconProps } from "./types";

/** Bold direction arrow (distinct from ChevronUpIcon's navigational chevron)
 * — used inside PickupMarker. */
export const ArrowUpIcon = ({ size = 16, color = "currentColor", className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 19V5M12 5l-6 6M12 5l6 6" stroke={color} strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
